import React, { useState } from 'react';
import teamImg from '../images/team.png';
import TeamsTab from './btcl100club/components/TeamsTab';
import MatchesTab from './btcl100club/components/MatchesTab';
import ScoreboardTab from './btcl100club/components/ScoreboardTab';
import LeagueTable from './leagues/components/LeagueTable';
import { motion, AnimatePresence } from 'framer-motion';

const DIVISION_ID = '128428';

function Btcl100Balls() {
    const [activeTab, setActiveTab] = useState('TEAMS');
    const isMobile = window.innerWidth <= 768;

    const styles = {
        outerSection: {
            background: '#FFFFFF',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
        },
        banner: {
            width: '100%',
            maxWidth: '1232px',
            height: isMobile ? '160px' : '256px',
            margin: isMobile ? '16px auto' : '32px auto',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            backgroundImage: `linear-gradient(rgba(6, 13, 138, 0.4), rgba(6, 13, 138, 0.4)), url(${teamImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            textAlign: 'center'
        },
        bannerTitle: {
            fontFamily: 'var(--fontAnton)',
            fontSize: isMobile ? '32px' : '64px',
            textTransform: 'uppercase',
            margin: '0 0 8px 0',
            fontWeight: 700,
            letterSpacing: '1px'
        },
        bannerSubtitle: {
            fontFamily: 'var(--fontRajdhani)',
            fontSize: isMobile ? '12px' : '18px',
            color: '#E7C424',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '2px',
            margin: 0
        },
        container: {
            width: '100%',
            maxWidth: '1232px',
            padding: isMobile ? '16px' : '32px 0px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: isMobile ? '24px' : '32px',
        },
        tabWrapper: {
            display: 'flex',
            justifyContent: isMobile ? 'flex-start' : 'center',
            gap: isMobile ? '8px' : '24px',
            width: '100%',
            flexWrap: isMobile ? 'nowrap' : 'wrap',
            overflowX: isMobile ? 'auto' : 'visible',
            padding: isMobile ? '4px 16px 16px 16px' : '0',
            WebkitOverflowScrolling: 'touch',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        tabBtn: (isActive) => ({
            padding: isMobile ? '10px 16px' : '12px 24px',
            minWidth: isMobile ? 'auto' : '160px',
            whiteSpace: 'nowrap',
            background: isActive ? '#060D8A' : 'transparent',
            border: isActive ? 'none' : '1px solid #060D8A',
            color: isActive ? '#FFFFFF' : '#060D8A',
            fontFamily: 'var(--fontRajdhani)',
            fontWeight: 700,
            fontSize: isMobile ? '13px' : '16px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            borderRadius: '4px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            flexShrink: 0,
        }),
        contentArea: {
            width: '100%',
            minHeight: '400px',
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'TEAMS': return <TeamsTab />;
            case 'MATCHES': return <MatchesTab />;
            case 'SCOREBOARD': return <ScoreboardTab />;
            case 'LEAGUE TABLE': return <LeagueTable id={DIVISION_ID} />;
            default: return <TeamsTab />;
        }
    };

    return (
        <div style={styles.outerSection}>
            {/* Banner Section with provided SVG header */}
            <div style={styles.banner}>
                <h1 style={styles.bannerTitle}>BTCL 100 BALLS TOURNAMENT</h1>
                <p style={styles.bannerSubtitle}>EXCITING CRICKET ACTION • SEASON 2025 • FAST PACED TOURNAMENT</p>
            </div>

            <div style={styles.container}>
                {/* Tab Navigation */}
                <div style={styles.tabWrapper}>
                    {['TEAMS', 'MATCHES', 'SCOREBOARD', 'LEAGUE TABLE'].map((tab) => (
                        <button 
                            key={tab}
                            style={styles.tabBtn(activeTab === tab)} 
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>

                {/* Tab Content Area */}
                <div style={styles.contentArea}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeTab}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -10 }}
                            transition={{ duration: 0.3 }}
                        >
                            {renderContent()}
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>
        </div>
    );
}

export default Btcl100Balls;
